import BlueRadial from "~/app/components/icons/DeFi/Misc/BlueRadial";

export const invisiblegradients = {

 light: {
    invisiblegradienthero: `
      linear-gradient(
        90deg,
        rgba(230, 240, 255, 0.5) 0%,
        rgba(240, 248, 255, 0.5) 50%,
        rgba(230, 240, 255, 0.5) 100%
      ),
      repeating-linear-gradient(
        45deg,
        rgba(0, 122, 255, 0.03) 0px,
        rgba(0, 122, 255, 0.03) 1px,
        transparent 1px,
        transparent 10px
      ),
      radial-gradient(
        circle at 50% 0%,
        rgba(0, 122, 255, 0.15) 0%,
        rgba(0, 122, 255, 0.05) 45%,
        transparent 70%
      ),
      linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.95) 0%,
        rgba(240, 248, 255, 0.9) 100%
      )`,
  
     invisiblegradientcard: `
         repeating-conic-gradient(
           from 0deg,
           rgba(1, 84, 254, 0.15) 1deg 1deg, 
           rgba(255, 255, 240, 0.01) 2deg 15deg
         )`, 

   invisiblegradient: `
      linear-gradient(
        90deg,
        rgba(230, 240, 255, 0.3) 0%,
        rgba(240, 248, 255, 0.3) 50%,
        rgba(230, 240, 255, 0.3) 100%
      ),
      repeating-linear-gradient(
        45deg,
        rgba(0, 122, 255, 0.02) 0px,
        rgba(0, 122, 255, 0.02) 1px,
        transparent 1px,
        transparent 8px
      ),
      radial-gradient(
        circle at 50% 50%,
        rgba(0, 122, 255, 0.1) 0%,
        rgba(0, 122, 255, 0.03) 45%,
        transparent 70%
      ),
      linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.97) 0%,
        rgba(240, 248, 255, 0.95) 100%
      )`,
  }, 

 dark: { 
  invisiblegradienthero: `
    linear-gradient(
      90deg,
      rgba(0, 122, 255, 0.03) 0%,
      rgba(0, 200, 255, 0.05) 50%,
      rgba(0, 122, 255, 0.03) 100%
    ),
    repeating-linear-gradient(
      90deg,
      rgba(0, 122, 255, 0.05) 0px,
      rgba(0, 122, 255, 0.03) 1px,
      transparent 1px,
      transparent 10px
    ),
    radial-gradient(
      circle at 50% 0%,
      rgba(0, 122, 255, 0.3) 0%,
      rgba(0, 122, 255, 0.2) 25%,
      transparent 50%
    ),
    linear-gradient(
      180deg,
      rgba(8, 12, 22, 0.97) 0%,
      rgba(12, 16, 28, 0.98) 100%
    )`,

    invisiblegradient: `
      linear-gradient(
        90deg,
        rgba(0, 122, 255, 0.02) 0%,
        rgba(0, 200, 255, 0.03) 50%,
        rgba(0, 122, 255, 0.02) 100%
      ),
      repeating-linear-gradient(
        45deg,
        rgba(0, 122, 255, 0.03) 0px,
        rgba(0, 122, 255, 0.03) 1px,
        transparent 1px,
        transparent 8px
      ),
      radial-gradient(
        circle at 50% 50%,
        rgba(0, 122, 255, 0.15) 0%,
        rgba(0, 122, 255, 0.1) 35%,
        transparent 60%
      ),
      linear-gradient(
        180deg,
        rgba(8, 12, 22, 0.95) 0%,
        rgba(12, 16, 28, 0.97) 100%
      )`,
 }, 
}
